import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const InputContainerBox = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
`;